import { makeStyles } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
import AppRoutes from './AppRoutes';
import { drawerWidth } from './AppConfig';

export type AppMainProps = {
    isMenuOpened: boolean
}

export function AppMain ({ isMenuOpened }: AppMainProps) {
    const cls = useStyles();

    return (
        <main
            className={clsx(cls.content, {
                [cls.contentShift]: isMenuOpened,
            })}
        >
            <AppRoutes />
        </main>

    )
}

const useStyles = makeStyles(theme => ({
    content: {
        flexGrow: 1,
        //padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
        })
    },

    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: drawerWidth,
    }
}));